import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoader = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "25 25 50 50",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 50,
		cy: 50,
		r: 20,
		fill: "none",
		strokeWidth: 2,
		strokeMiterlimit: 10
	})
});
export default SvgLoader;
